import React, { Component } from 'react'
import ModuleContainer from '../../components/ModuleContainer';
import { Form, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import ViewHeader from '../../components/ViewHeader';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import { pollOperations } from './state';
import { SUCCESS, NOTIF_SUCCESS, NOTIF_ERROR, EMPTY_STRING, ADD_MANUALVOTES, PARAMS, BACK, SUBMIT, NO, SECONDARY, YES, SUCCESS_BUTTON} from '../../../utils/constants';
import { SideNotification } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, MSG_ADDED_MANUAL_VOTES, SAVE_CHANGES, MSG_CONFIRM_CHANGES } from '../../../utils/messages';
import { VIEW_POLL_ROUTE } from './routes';
import ConfirmationModal from '../../components/ConfirmationModal';
import debounce from 'lodash.debounce';

class AddManualVotes extends Component {

    constructor(props) {
        super(props)
        this.state = {
            pollSelections: this.props.poll.pollSelections,
            numberOfVotes: 0,
            data: '',
            pollSelectionsWithVotes: [],
            pollId: 0,
            pollManualVotes: [],
            errorFlag: false,
            showSaveModal: false
        }
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
    }

    componentDidMount() {
        let id = PARAMS !== this.props.match.params.id && this.props.match.params.id;
        this.setState({
            pollId: id,
            pollSelections: this.props.poll.pollSelections
        })
    }

    handleInputChange = (event, selectionIdx, choiceIdx) => {

        let data = event.target.value
        let selections = this.state.pollSelections
        let selectionList = selections[selectionIdx]
        let tempList = selectionList.choiceListWithResult[choiceIdx]
        tempList.manualVotesCount = Number(data)
        if (999999 < Number(data)) {
            tempList.errorFlag = true
            this.setState({
                errorFlag: true
            })
        }
        else {
            tempList.errorFlag = false
            this.setState({
                errorFlag: false
            })
        }

        this.setState({
            pollSelections: selections
        })

    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }



    saveChanges = () => {

        let data = this.state.pollSelections
        let votes = []
        data.map((result) => {
            result.choiceListWithResult.map((res) => {

                let pollManualVote = {
                    "pollId": result.pollId,
                    "selectionId": result.selectionId,
                    "voteCount": res.manualVotesCount,
                    "choiceId": res.pollSelectionChoiceModel.choiceId,
                    "pManualId": res.manualVotesId
                }
                votes = [...votes, pollManualVote]
                return EMPTY_STRING;
            })
            return EMPTY_STRING;
        })
        this.props.insertPollManualVotes(votes, this.state.pollId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, MSG_ADDED_MANUAL_VOTES);
                    this.props.history.push({ pathname: VIEW_POLL_ROUTE + `/${this.state.pollId}` })
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    withSearch={false}
                    title={ADD_MANUALVOTES}
                    rightButtons={[
                        { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push({ pathname: VIEW_POLL_ROUTE + `/${this.state.pollId}` }) },
                        { variant: SUCCESS_BUTTON, label: SUBMIT, icon: FaCheck, onClick: this.toggleSave, disabled: this.state.errorFlag }
                    ]}
                />
                {this.state.pollSelections && this.state.pollSelections.map((data, idx) => {
                    return (
                        <div key={idx}>
                            <b><span>{data.selectionTitle}</span></b><br />
                            {data.choiceListWithResult.map((values, index) => {
                                return (
                                    <div key={index}>
                                        <Row className="manualvote-choice">
                                            <span className="vote-choicelabel">{values.pollSelectionChoiceModel.choiceLabel}</span>
                                            <Form.Control type="number" value={values.manualVotesCount} onChange={(event) => this.handleInputChange(event, idx, index)} className="vote-input" name={this.state.numberOfVotes} />
                                        </Row>
                                        {(values.errorFlag) &&
                                            (<p className="manualvotes-error">{}</p>)}
                                    </div>
                                )
                            })}
                        </div>

                    )
                })}

                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

            </ModuleContainer>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        poll: state.polls.poll
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        insertPollManualVotes: pollOperations.insertPollManualVotes
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(AddManualVotes);